import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ServiceAvatar } from "./columns";
import { AvatarForm } from "./avatar-form";

interface AvatarDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: ServiceAvatar) => void;
  initialData?: ServiceAvatar;
  isEditing: boolean;
}

export function AvatarDialog({
  open,
  onOpenChange,
  onSubmit,
  initialData,
  isEditing,
}: AvatarDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{isEditing ? "Edit Avatar" : "Add Avatar"}</DialogTitle>
          <DialogDescription>
            {isEditing
              ? "Edit your service avatar settings."
              : "Add a new service avatar to your collection."}
          </DialogDescription>
        </DialogHeader>
        <AvatarForm 
          onSubmit={onSubmit} 
          onCancel={() => onOpenChange(false)}
          initialData={initialData} 
        />
      </DialogContent>
    </Dialog>
  );
}
